import React from 'react'
import { useContext } from 'react'
import AppContext from '../context/appContext'
import { formatEther, parseEther } from 'viem'
import { useEffect, useState } from 'react'
import { config } from './config'
import { abi, deployedaddr } from '../contract/info'
import { useWriteContract, useWaitForTransactionReceipt, useTransaction } from 'wagmi'
const AdminWithdraws = () => {
    const appContext = useContext(AppContext)
    const { allUsers, confirmWithdraw ,setMainLoader} = appContext
    const totalAmount = allUsers.reduce((sum, tx) => sum + Number(tx.amount), 0);
    const totalWithdraws = allUsers.reduce((sum, tx) => sum + Number(tx.withdraws.length), 0);

    const totalWithdrawAmount = allUsers.reduce((sum, tx) => sum + Number(tx.withdraws.reduce((sum, thx) => sum + Number(thx.amount), 0)), 0);

    const totalPendingWithdraws = allUsers.reduce((count, user) => {
        return count + user.withdraws.filter(withdraw => withdraw.status === "pending").length;
    }, 0);
    const totalCompletedWithdraws = allUsers.reduce((count, user) => {
        return count + user.withdraws.filter(withdraw => withdraw.status === "Completed").length;
    }, 0);


    const totalPendingWithdrawsAmount = allUsers.reduce((count, user) => {
        return count + user.withdraws.filter(withdraw => withdraw.status === "pending").reduce((sum, tx) => sum + Number(tx.amount), 0);
    }, 0);

    const totalCompletedWithdrawsAmount = allUsers.reduce((count, user) => {
        return count + user.withdraws.filter(withdraw => withdraw.status === "Completed").reduce((sum, tx) => sum + Number(tx.amount), 0);
    }, 0);

    console.log(totalPendingWithdrawsAmount);


    console.log(totalPendingWithdraws);


    console.log(totalWithdrawAmount);
    console.log(totalWithdraws);
    console.log(totalAmount);

    let globalIndex = 1






    const { data: transferData, writeContract, error, isSuccess } = useWriteContract(

    )
    console.log(error);

    console.log(transferData);

    // console.log(`The Transaction Success: ${isSuccess}`)



    const { isError, isLoading, data: transactionData,isSuccess:txSuccess } = useWaitForTransactionReceipt({
        hash: transferData,
        confirmations: 1,
        query: {
            refetchOnWindowFocus: false,  // 👈 Prevents refetch on tab switch
        },
        chainId:56,
        config

    })

    useEffect(() => {
      if(isLoading){
        setMainLoader(true)
      }
      else{
        setMainLoader(false)
      }
    }, [isLoading])
    


    // const { data: transaction, isSuccess: txSuccess } = useTransaction({
    //     hash: transferData
    // });

    // console.log(isError)
    // console.log();

    

    console.log(`TRANSACTION: ${txSuccess}`)
    console.log(`The Transaction Success: ${txSuccess}`)
    // console.log(transaction)


    // console.log(transaction, isLoading, isError);


    function sendWithdraw(to, amount) {

        writeContract({
            abi,
            address: deployedaddr,
            functionName: 'transfer',
            args: [to, amount]



        })


        // console.log(amount);


    }

    console.log(`The successful Transaction: ${txSuccess}`);

    const [withdrawInfo, setWithdrawInfo] = useState(null)

    useEffect(() => {
        if (txSuccess) {
            confirmWithdraw(withdrawInfo.ID, withdrawInfo.wID)
        }
    }, [txSuccess])


    console.log(withdrawInfo);

    function formatDate(isoString) {
        const date = new Date(isoString);
        const day = String(date.getUTCDate()).padStart(2, '0');
        const month = String(date.getUTCMonth() + 1).padStart(2, '0'); // Months are 0-based
        const year = String(date.getUTCFullYear()).slice(-2);

        return `${day}/${month}/${year}`;
    }
    // console.log(userData);
    return (
        <div>
            <div className="px-md-5">
                <h1 className="text-light">Withdraw Requests</h1>
            </div>

            <div className="px-md-5">

                <div className="row">
                    <div className="col-sm-6 col-lg-4 col-12 my-2">
                        <div class="card h-100 rounded-4 overflow-hidden" style={{ borderColor: "#fff", backgroundColor: "#23153c" }}>
                            {/* <img src="..." class="card-img-top" alt="..."/> */}
                            <div className='px-5 pb-3 pt-4' style={{ borderRadius: '100%' }}>
                                <p className='display-6 h1 text-light' style={{ fontWeight: "bold" }}>{totalWithdraws}</p>
                            </div>
                            <div class="card-body d-flex flex-column">
                                <h2 class="card-title text-light">Total Withdraws                                  </h2>
                                <p class="card-text text-light">Fully audited smart contract with zero human intervention</p>

                            </div>
                        </div>
                    </div>
                    <div className="col-sm-6 col-lg-4 col-12 my-2">
                        <div class="card h-100 rounded-4 overflow-hidden" style={{ borderColor: "#fff", backgroundColor: "#23153c" }}>
                            {/* <img src="..." class="card-img-top" alt="..."/> */}
                            <div className='px-5 pb-3 pt-4' style={{ borderRadius: '100%' }}>
                                <p className='display-6 h1 text-light' style={{ fontWeight: "bold" }}>{totalWithdrawAmount}$</p>
                            </div>
                            <div class="card-body d-flex flex-column">
                                <h2 class="card-title text-light">Withdraws Amount                                  </h2>
                                <p class="card-text text-light">Fully audited smart contract with zero human intervention</p>

                            </div>
                        </div>
                    </div>

                    <div className="col-sm-6 col-lg-4 col-12 my-2">
                        <div class="card h-100 rounded-4 overflow-hidden" style={{ borderColor: "#fff", backgroundColor: "#23153c" }}>
                            {/* <img src="..." class="card-img-top" alt="..."/> */}
                            <div className='px-5 pb-3 pt-4' style={{ borderRadius: '100%' }}>
                                <p className='display-6 h1 text-light' style={{ fontWeight: "bold" }}>{totalPendingWithdraws}</p>
                            </div>
                            <div class="card-body d-flex flex-column">
                                <h2 class="card-title text-light">Total Pending Withdraws                                  </h2>
                                <p class="card-text text-light">Fully audited smart contract with zero human intervention</p>

                            </div>
                        </div>
                    </div>
                    <div className="col-sm-6 col-lg-4 col-12 my-2">
                        <div class="card h-100 rounded-4 overflow-hidden" style={{ borderColor: "#fff", backgroundColor: "#23153c" }}>
                            {/* <img src="..." class="card-img-top" alt="..."/> */}
                            <div className='px-5 pb-3 pt-4' style={{ borderRadius: '100%' }}>
                                <p className='display-6 h1 text-light' style={{ fontWeight: "bold" }}>{totalPendingWithdrawsAmount}$</p>
                            </div>
                            <div class="card-body d-flex flex-column">
                                <h2 class="card-title text-light">Total Pending Withdraws Amount                                </h2>
                                <p class="card-text text-light">Fully audited smart contract with zero human intervention</p>

                            </div>
                        </div>
                    </div>
                    <div className="col-sm-6 col-lg-4 col-12 my-2">
                        <div class="card h-100 rounded-4 overflow-hidden" style={{ borderColor: "#fff", backgroundColor: "#23153c" }}>
                            {/* <img src="..." class="card-img-top" alt="..."/> */}
                            <div className='px-5 pb-3 pt-4' style={{ borderRadius: '100%' }}>
                                <p className='display-6 h1 text-light' style={{ fontWeight: "bold" }}>{totalCompletedWithdraws}</p>
                            </div>
                            <div class="card-body d-flex flex-column">
                                <h2 class="card-title text-light">Total Completed Withdraws                                </h2>
                                <p class="card-text text-light">Fully audited smart contract with zero human intervention</p>

                            </div>
                        </div>
                    </div>
                    <div className="col-sm-6 col-lg-4 col-12 my-2">
                        <div class="card h-100 rounded-4 overflow-hidden" style={{ borderColor: "#fff", backgroundColor: "#23153c" }}>
                            {/* <img src="..." class="card-img-top" alt="..."/> */}
                            <div className='px-5 pb-3 pt-4' style={{ borderRadius: '100%' }}>
                                <p className='display-6 h1 text-light' style={{ fontWeight: "bold" }}>{totalCompletedWithdrawsAmount}$</p>
                            </div>
                            <div class="card-body d-flex flex-column">
                                <h2 class="card-title text-light">Total Completed Withdraws Amount                               </h2>
                                <p class="card-text text-light">Fully audited smart contract with zero human intervention</p>

                            </div>
                        </div>
                    </div>
                </div>
                <h1 className="text-light my-4">Withdraw Requests</h1>
                <div className="table-responsive">
                    <table class="table">

                        <thead>
                            <tr>
                                <th style={{ backgroundColor: "#23153c", color: "white" }} scope="col">#</th>
                                <th style={{ backgroundColor: "#23153c", color: "white" }} scope="col">Address</th>
                                <th style={{ backgroundColor: "#23153c", color: "white" }} scope="col">Amount</th>
                                <th style={{ backgroundColor: "#23153c", color: "white" }} scope="col">Date</th>
                                <th style={{ backgroundColor: "#23153c", color: "white" }} scope="col">Status</th>
                                <th style={{ backgroundColor: "#23153c", color: "white" }} scope="col">Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {allUsers.map((element, i) => {
                                return element.withdraws.map((e, i) => {
                                    return < tr >
                                        <th style={{ backgroundColor: "#23153c", color: "white" }} scope="row">{globalIndex++}</th>
                                        <td style={{ backgroundColor: "#23153c", color: "white" }} scope="row">{element.walletAddress}</td>
                                        <td style={{ backgroundColor: "#23153c", color: "white", fontWeight: "bold" }}>{e.amount}$</td>
                                        <td style={{ backgroundColor: "#23153c", color: "white" }}>{formatDate(e.date)}</td>
                                        <td style={{ backgroundColor: "#23153c", color: "white" }}>{e.status}</td>
                                        <td style={{ backgroundColor: "#23153c", color: "white" }}>
                                            {e.status == "pending" && <button onClick={() => {
                                                sendWithdraw(element.walletAddress, parseEther(e.amount));
                                                setWithdrawInfo({ ID: element._id, wID: e._id })
                                                // console.log(parseEther(e.amount))
                                            }} className="btn btn-outline-light">Send</button>}

                                        </td>
                                    </tr>
                                })

                            })

                            }


                        </tbody>
                    </table>
                </div>
            </div>
        </div >
    )
}

export default AdminWithdraws